import { useMatch } from 'react-router';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

import InternalErrorState from '@/features/app/InternalErrorState';
import { useFetchBatteryPackLevelsQuery } from '@/features/battery/api/batterySlice';
import { PackLevelDetailsDialog } from '@/features/battery/workshop/PackLevelDetailsDialog';
import { LoadingScreen } from '@/features/batteryOverview/utils/BatteryDataUtils';

const PackLevelPage = () => {
    const assetId = useMatch('/dialog/pack-levels/:assetId')?.params.assetId;
    const { isLoading, isError, error, data: batteryLevel, refetch } = useFetchBatteryPackLevelsQuery(assetId!);

    if (isLoading) {
        return <LoadingScreen />;
    }
    if (isError) {
        return (
            <InternalErrorState
                errorCode={(error as FetchBaseQueryError).status as number}
                reloadTriggerFunction={refetch}
            />
        );
    }

    if (!batteryLevel) {
        return null;
    }

    return <PackLevelDetailsDialog batteryPackLevel={batteryLevel} />;
};

export default PackLevelPage;
